import DapDSTimePicker from './timepicker.component'

export * from './timepicker.component'
export default DapDSTimePicker

DapDSTimePicker.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-timepicker': DapDSTimePicker
  }
}
